import * as API from "../../../services/httpService"
import { navigate } from "gatsby"
import { parse } from "date-fns"
import {
  increment,
  controlLoading,
  controlDeclaration,
  receivedSubmitStatus,
} from "../../../Redux/WindscreenClaim/actions"
import * as Constants from "../../../common/constants"

const SubmitClaim = (dispatch, uiData, claimData) => {
  const checkDateExist = (date, time) => {
    if (typeof date !== "undefined") {
      return Constants.combineDateAndTime(date, time)
    }
  }

  //If user entered master account to claim
  if (uiData.isMasterAccClaim) {
    //Set masterAccountNumber field as user entered policy number
    let userEnteredMasterAccount = claimData.claimInfo.policyInfo.policyNumber
    claimData.claimInfo.policyInfo.masterAccountNumber = userEnteredMasterAccount

    //Set policyNumber field as TiqConnet API returned policy number
    claimData.claimInfo.policyInfo.policyNumber =
      claimData.claimInfo.policyInfo.policyNumberOfMasterAccount
  }

  if (claimData.claimInfo.claimAttributeModel.policyStartDate) {
    claimData.claimInfo.claimAttributeModel.policyStartDate = parse(
      claimData.claimInfo.claimAttributeModel.policyStartDate,
      `d${Constants.sep}M${Constants.sep}yyyy`,
      new Date()
    )
  }

  if (claimData.claimInfo.claimAttributeModel.policyEndDate) {
    claimData.claimInfo.claimAttributeModel.policyEndDate = parse(
      claimData.claimInfo.claimAttributeModel.policyEndDate,
      `d${Constants.sep}M${Constants.sep}yyyy`,
      new Date()
    )
  }

  if (typeof claimData.claimInfo.policyInfo.claimAmount !== "undefined") {
    //Claim amount filter "," and comvert to decimal
    claimData.claimInfo.policyInfo.claimAmount = parseFloat(
      claimData.claimInfo.policyInfo.claimAmount.toString().replace(/,/g, "")
    )
  }

  claimData.claimInfo.policyInfo.accidentDate = checkDateExist(
    claimData.claimInfo.policyInfo.accidentDate,
    claimData.claimInfo.policyInfo.accidentTime
  )

  if (claimData.claimInfo.policyInfo.workshop === "Others") {
    claimData.claimInfo.policyInfo.workshopName =
      claimData.claimInfo.policyInfo.otherWorkshopName
  } else {
    claimData.claimInfo.policyInfo.workshopName =
      claimData.claimInfo.policyInfo.workshop
  }
  if (claimData.claimInfo.policyInfo.driverOccupation === "Others") {
    claimData.claimInfo.policyInfo.driverOccupation =
      claimData.claimInfo.policyInfo.otherDriverOccupation
  }
  if (
    claimData.claimInfo.policyInfo.natureOfDamage ===
    Constants.natureOfDamageOther
  ) {
    claimData.claimInfo.policyInfo.natureOfDamage =
      claimData.claimInfo.policyInfo.otherNatureOfDamage
  }
  claimData.claimInfo.policyInfo.declaration = uiData.checkBoxStatus.isAgree

  // console.log(
  //   JSON.stringify({
  //     claimHeaderModel: claimData.claimInfo.policyInfo,
  //     claimMaidDetailModel: claimData.claimInfo.policyInfo,
  //     maidMedicalListModel: tempMaidMedicalListModel,
  //     maidLossListModel: tempMaidLossListModel,
  //     maidHospitalSurgicalModel: tempMaidHospitalSurgical,
  //     maidLiabilityModel: tempMaidLiability,
  //     claimUploadListModel: uiData.claimUploadListModel,
  //     folderName: uiData.folderName,
  //     // sessionId: "",
  //   })
  // )

  API.apiPostRequest(
    "/Claim/WindscreenSubmitClaim",
    {
      claimAttributeModel: claimData.claimInfo.claimAttributeModel,
      claimHeaderModel: claimData.claimInfo.policyInfo,
      claimWindscreenDetailModel: claimData.claimInfo.policyInfo,
      claimWindscreenItems: claimData.claimInfo.claimWindscreenItems,
      claimUploadListModel: uiData.claimUploadListModel,
      folderName: uiData.folderName,
      // sessionId: "",
    },
    null
  ).then(
    submitClaimResponse => {
      // console.log(submitClaimResponse)
      dispatch(controlDeclaration())
      dispatch(increment())
      dispatch(
        receivedSubmitStatus(submitClaimResponse.data.ClaimRequestNumber)
      )
      dispatch(controlLoading())
    },
    error => {
      navigate("ErrorOccurred")
    }
  )
}

export default SubmitClaim
